import CreditAccountPayment from 'app/src/payments/CreditAccountPayment';
import Payment from 'app/src/payments/Payment';

/**
 * Class definition of a deposit payment.  Deposit payments are essentially a regular payment
 * mixed with a negated credit account payment (to balance the operation).  We've opted to create
 * a new payment type to simplify it's use by the Sale Manager but also to allow us to absorb any
 * special logic in a deposit abstraction. (e.g. keeping a reference to the deposit payment)
 */
export default class DepositPayment extends CreditAccountPayment {
  /**
   * Constructor
   *
   * @param {Decimal} payment   The amount of the gift card payment
   * @param {Number} creditAccountID  The ID of of the credit account associated with the deposit
   */
  constructor(payment = new Payment(0), creditAccountID = 0) {
    super(payment.amount.negated(), creditAccountID);

    // store the payment so we can use it for referencing if necessary
    this.depositPayment = payment;
  }

  /**
   * Setter for the deposit payment
   *
   * @param {Payment} payment     The deposit payment
   */
  set depositPayment(payment) {
    this._depositPayment = payment;
  }

  /**
   * Getter for the deposit payment
   *
   * @returns {Payment}
   */
  get depositPayment() {
    return this._depositPayment;
  }

  /**
   * Creates a clone of the payment
   *
   * @returns {*}
   */
  clone() {
    let clone = super.clone();

    // clone deposit specific data
    clone.depositPayment = this.depositPayment.clone();

    return clone;
  }
}
